import { render, staticRenderFns } from "./IconTriangleAlert.vue?vue&type=template&id=997cc286"
import script from "./IconTriangleAlert.vue?vue&type=script&lang=js"
export * from "./IconTriangleAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports